// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","bodyField":"App_bodyField__wvSWg","fullWidth":"App_fullWidth__Q531I","infoBottomBgImg":"App_infoBottomBgImg__rbPqg"};